import {
  ITimeLineItem,
  TimelineContentItem,
  WSTimelineProps
} from "@wingspanhq/fe-component-library";
import {
  ICollaboratorSchema,
  IForm1099Events,
  IMemberClientForm1099Balances
} from "@wingspanhq/payments/dist/interfaces";
import { startCase } from "lodash";
import { US_STATES_OPTIONS } from "../../constants/user";
import {
  getCollaboratorCompany,
  getCollaboratorName,
  getCurrentYearForm1099Balances
} from "../../query/payments/selectors";
import styles from "../screens/NEC1099FilingDetails/NEC1099FilingDetails.module.scss";

export type FillingYear = keyof ICollaboratorSchema["form1099Balances"];

export const CURRENT_FILING_YEAR: FillingYear = 2022;

export const TAX_ID_REQUIRED_STATES = [
  {
    label: "Alabama",
    value: "AL"
  },
  {
    label: "Delaware",
    value: "DE"
  },
  {
    label: "Kansas",
    value: "KS"
  },
  {
    label: "Mississippi",
    value: "MS"
  },
  {
    label: "North Dakota",
    value: "ND"
  },
  {
    label: "Oregon",
    value: "OR"
  },
  {
    label: "Pennsylvania",
    value: "PA"
  }
];

export const getCurrentFilingYear = () => {
  return CURRENT_FILING_YEAR;
};

export const getActivityFrom1099Events = (
  collaborator: ICollaboratorSchema
): WSTimelineProps["timelines"] => {
  const { form1099Balances } = collaborator;
  const Form1099EventToDisplayEventMap = {
    submittedForCollaboratorReviewAt: "Submitted for collaborator review",
    suggestionMadeAt: `Suggestion made by ${getCollaboratorName(collaborator)}`,
    suggestionResolvedAt: `Suggestion resolved by ${getCollaboratorCompany(
      collaborator
    )}`,
    submittedAt: "Submitted",
    rejectedByIrsAt: "Rejected by IRS",
    correctedVersionSubmittedAt: "Corrected version submitted",
    acceptedByIrsAt: "Accepted by IRS",
    deliveredElectronicallyAt: "Delivered electronically",
    deliveredByMailAt: "Delivered by mail",
    openedByCollaboratorAt: `Opened by ${getCollaboratorName(collaborator)}`
  };

  const currentYearForm1099Balances = getCurrentYearForm1099Balances(
    collaborator
  );
  const events = currentYearForm1099Balances?.events || {};

  const form1099EventToWSTimelineItem = (key: string): ITimeLineItem => {
    const baseTimelineItem = {
      content: {
        datetime: events[key as keyof IForm1099Events] as Date,
        description:
          Form1099EventToDisplayEventMap[key as keyof IForm1099Events] ??
          startCase(key)
      }
    };

    switch (key) {
      case "acceptedByIrsAt":
        return {
          ...baseTimelineItem,
          dotProps: {
            type: "icon",
            icon: "successMark",
            color: "green500",
            backgroundColor: "green100"
          }
        };
      case "rejectedByIrsAt":
        return {
          ...baseTimelineItem,
          dotProps: {
            className: styles.rejectIcon,
            type: "icon",
            icon: "close",
            color: "red500",
            backgroundColor: "red100"
          }
        };
      default:
        return {
          ...baseTimelineItem
        };
    }
  };

  const eventsArray = Object.keys(events).map(form1099EventToWSTimelineItem);

  return eventsArray
    .sort((event1, event2) => {
      return (
        (event2.content as TimelineContentItem)?.datetime?.getTime() -
        (event1.content as TimelineContentItem)?.datetime?.getTime()
      );
    })
    .map((item, index) => {
      if (index === 0) {
        return {
          ...item,
          dotProps: {
            type: "outline"
          }
        };
      }
      return item;
    });
};
